import styled from "styled-components";

/* ── Create Form Layout ── */
export const CreateFormContainer = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  gap: 0;
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: #1a1a2e;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #3fc4fd;
  font-size: 16px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: background 0.15s;
  &:hover {
    background: #eef0ff;
  }
`;

export const FormSection = styled.div`
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 18px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 14px;
  &:last-child {
    margin-bottom: 0;
  }
  &.three-col > * {
    flex: 1 1 33%;
  }
  &.four-col > * {
    flex: 1 1 25%;
  }
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  flex: 1 1 48%;
  display: flex;
  flex-direction: column;
  &.full {
    flex: 1 1 100%;
  }
`;

export const FormLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-bottom: 6px;
  text-transform: capitalize;
  &.required::after {
    content: " *";
    color: #d32f2f;
  }
`;

export const FormInput = styled.input`
  padding: 10px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  outline: none;
  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(91, 95, 199, 0.1);
  }
  &:disabled {
    background: #f5f7fa;
    color: #888;
    cursor: default;
  }
  &::placeholder {
    color: #aab0bc;
  }
`;

export const FormSelect = styled.select`
  padding: 10px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  outline: none;
  cursor: pointer;
  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(91, 95, 199, 0.1);
  }
`;

export const FormTextArea = styled.textarea`
  padding: 12px 14px;
  border: 1.5px solid #dce1e8;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
  background: #fff;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.15s, box-shadow 0.15s;
  outline: none;
  min-height: 80px;
  &:focus {
    border-color: #3fc4fd;
    box-shadow: 0 0 0 3px rgba(91, 95, 199, 0.1);
  }
  &::placeholder {
    color: #aab0bc;
  }
`;

/* ── Invoice Items ── */
export const ItemsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  h3 {
    margin: 0;
  }
`;

export const ItemCard = styled.div`
  background: #f8fafd;
  border: 1px solid #e8ecf1;
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 12px;
`;

export const ItemNumber = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #888;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ItemRow = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const AddItemButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #3FC4FD;
  color: #ffffff;
  border-radius: 10px;
  border: none;
  margin: 0px;
  cursor: pointer;
  padding: 0.5em 1em;
  margin-right: 0em;
  outline: none;
  height: 40px;
  border: 0px solid #81d9ff;
  margin-left: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: bold;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;

export const RemoveItemButton = styled.button`
  background: none;
  border: none;
  color: #d32f2f;
  font-size: 16px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  transition: background 0.15s;
  &:hover {
    background: #ffeaea;
  }
`;

/* ── Totals ── */
export const TotalsSection = styled.div`
  background: #f0f4ff;
  border-radius: 10px;
  padding: 16px 20px;
  margin-top: 16px;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
`;

export const TotalLabel = styled.span`
  font-size: 16px;
  color: #555;
`;

export const TotalValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a2e;
`;

export const TotalDivider = styled.hr`
  border: none;
  border-top: 1px solid #d0d7e8;
  margin: 8px 0;
`;

export const GrandTotalLabel = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
`;

export const GrandTotalValue = styled.span`
  font-size: 17px;
  font-weight: 700;
  color: ##1a1a2e;
`;

export const TaxNote = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 6px;
  font-style: italic;
`;

/* ── Submit ── */
export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0 24px 0;
  &.floating {
    position: absolute;
    top: 62px;
    right: 175px;
    padding: 0;
    z-index: 10;
  }

  &.en {
    right: 150px;
  }
  
  @media (max-width: 768px){
    &.floating {
      right: 70px;
      top: 38px;
    }
    span {
      display: none;
    }
  }
`;

export const SubmitButton = styled.button`
  padding: 12px 32px;
  background: #3FC4FD;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  // &:hover {
  //   background: #3FC4FD;
  // }
  &:active {
    transform: scale(0.98);
  }
  &:disabled {
    background: #3FC4FD4f;
    cursor: not-allowed;
  }
`;

/* ── Legacy exports (kept for compatibility) ── */
export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
`;

export const TabHeader = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 0;
  align-items: flex-end;
  height: 60px;
`;

export const Tab = styled.div`
  padding: 0px;
  background-color: white;
  display: none;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  ${(props) =>
    props.active &&
    `
    display: flex;
  `}
`;

export const TabLink = styled.div`
  cursor: pointer;
  padding: 10px;
  flex: 1 1 50%;
  background-color: #d5e4ed;
  color: #838384;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 30px;
  &:first-child {
    border-top-left-radius: 10px;
  }
  &:last-child {
    border-top-right-radius: 10px;
  }
  &.active {
    background-color: #ffffff;
    color: #1381c5;
    height: 40px;
    box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    font-weight: 600;
    font-size: 18px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  flex: 1 1 100%;
  box-shadow: rgb(0 0 0 / 16%) 0px 1px 4px;
  padding: 0;
  margin-bottom: 1em;
  margin: 1em;
  border-radius: 10px;
  background: #f3f8fb;
  padding-bottom: 10px;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  ${(props) => {
    switch (props.status) {
      case "paid":
        return "background: #e6f9ee; color: #1a8a4a;";
      case "sent":
        return "background: #e6f0ff; color: #1a5cb8;";
      case "draft":
        return "background: #f0f0f0; color: #666;";
      case "overdue":
        return "background: #fff0e6; color: #cc5500;";
      case "cancelled":
        return "background: #ffe6e6; color: #cc0000;";
      default:
        return "background: #f0f0f0; color: #666;";
    }
  }}
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: #f0f7ff;
    border-color: #1381c5;
    color: #1381c5;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const InvoiceCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  margin: 1em;
  overflow: hidden;
`;

export const InvoiceCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #eee;
  h3 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
`;

export const InvoiceCardBody = styled.div`
  padding: 20px;
`;

export const InvoiceDetailRow = styled.div`
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
  }
`;

export const InvoiceDetailLabel = styled.div`
  flex: 0 0 180px;
  font-weight: 600;
  color: #666;
  font-size: 16px;
`;

export const InvoiceDetailValue = styled.div`
  flex: 1;
  color: #333;
  font-size: 16px;
`;
